import React from 'react';
import { MapPin } from 'lucide-react';
import FadeInOnScroll from './FadeInOnScroll';
import { serviceAreas } from '../data/serviceAreas';

const AreasWeServeSection = () => {
  return (
    <section
      id="areas-we-serve"
      className="py-20 px-6 relative overflow-hidden bg-white"
      data-testid="areas-we-serve-section"
    >
      <div
        aria-hidden="true"
        className="absolute -top-32 -left-32 w-96 h-96 rounded-full opacity-[0.06]"
        style={{ background: 'radial-gradient(circle, #00B3B3 0%, transparent 70%)' }}
      />

      <div className="max-w-6xl mx-auto relative">
        <FadeInOnScroll className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Areas We Serve
          </h2>
          <div className="w-24 h-1 mx-auto mb-5" style={{ backgroundColor: '#00B3B3' }} />
          <p className="text-gray-600 max-w-2xl mx-auto">
            Proudly serving Lake County, Illinois and the surrounding communities.
            Walk-ins welcome from anywhere — we&apos;re right on Route 83.
          </p>
        </FadeInOnScroll>

        <FadeInOnScroll>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {serviceAreas.map((area) => (
              <div
                key={`${area.city}-${area.zip}`}
                className="group flex items-center gap-2 px-4 py-3 rounded-xl border border-gray-200 bg-white hover:border-transparent transition-all duration-300"
                style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'linear-gradient(135deg, rgba(0,179,179,0.08) 0%, rgba(20,227,227,0.05) 100%)';
                  e.currentTarget.style.boxShadow = '0 8px 24px -8px rgba(0,179,179,0.25)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                }}
                data-testid={`area-${area.city.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <MapPin className="w-4 h-4 flex-shrink-0" style={{ color: '#00B3B3' }} />
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-gray-900 truncate">{area.city}</p>
                  <p className="text-[11px] text-gray-500">{area.zip}</p>
                </div>
              </div>
            ))}
          </div>
        </FadeInOnScroll>

        <FadeInOnScroll delay={150}>
          <p className="text-center text-gray-500 text-sm mt-10">
            Not on the list? We still want to help — call{' '}
            <a href="tel:2244199922" className="font-semibold" style={{ color: '#00B3B3' }}>
              (224) 419-9922
            </a>{' '}
            or send us a message.
          </p>
        </FadeInOnScroll>
      </div>
    </section>
  );
};

export default AreasWeServeSection;
